import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Select, DatePicker, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { typeOption } from "../../../utils/Helpers";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as issuesActions from "../../../redux/actions/issues.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

const { RangePicker } = DatePicker;

const IssueFilters = (props) => {
  const [postDataZone, setPostDataZone] = useState([]);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);
  const [issuePicked, setIssuePicked] = useState([
    {value: "", label: "All"},
    {value: "true", label: "Picked"},
    {value: "false", label: "Non Picked"},
  ]);
  const [issueTypeCategory] = useState([
    {value: "", label: "All"},
    {value: "rs_pickup", label: "RS Pickup"},
    {value: "rs_delivery", label: "RS Delivery"},
    {value: "cs", label: "CS"},
    {value: "mart", label: "Mart"},
    {value: "growth", label: "Growth"},
  ]);
  
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.pageFilter){
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter])

  useEffect(() => {
    postLists()
  }, []);

  const postLists = useCallback(async() => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }, [])
  
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.map((item) => {
        zoneData.push({value: item?.id, label: item?.zoneName});
        zoneDataAll.push(item?.id);
      });
      setPostDataZoneIdsAll(zoneDataAll)
      setPostDataZone([ {value: 'all', label: "All"}, ...zoneData]);
    }
  }, [props.zoneData]);

  const filterChange = async (value) => {
    const pageData = {
      ...props.pageFilter,
      ...value,
      page: 1,
    };
    props.issuesActions.filterAction(pageData);
    // props.setDataFilters(pageData)
  }

  const filterreset = async () => {
    const pageData = {
      page: 1,
      limit: 10,
    };
    props.issuesActions.filterAction(pageData);
    // props.setDataFilters(pageData)
    form.resetFields();
  }

  const onChangeHandelZone = async (value) => {
    if(value?.includes("all")){
      form.setFieldsValue({
        ...props.pageFilter,
        zone: postDataZoneIdsAll
      });
    }
  }
  
  const datevalue=(value1, value2) => {
    const date1 = value1 == undefined || value1 == "" ? "" : moment(value1)
    const date2 = value2 == undefined || value2 == "" ? "" : moment(value2)
    const datevalue = (value1 == undefined || value1 == "") && (value2 == undefined || value2 == "") ? "":[date1, date2];
    return datevalue;
  }

  return (
    <Form form={form} className="fliters_form" disabled={loading || props?.pageLoader} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public', date: datevalue(moment(), moment()) }}>
      <Form.Item
       name={["zone"]}
       label={(<>Search Zone</>)}
      >
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          onChange={onChangeHandelZone}
          style={{ minWidth: 220,}}
        />
      </Form.Item>
      <Form.Item
       name={["type"]}
       label={(<>Issue</>)}
      >
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={typeOption}
          style={{ minWidth: 160,}}
        />
      </Form.Item>
      <Form.Item
       name={["issues_type_category"]}
       label={(<>Issues Category</>)}
      >
        <Select
          showSearch
          allowClear
          options={issueTypeCategory}
          style={{ minWidth: 120,}}
        />
      </Form.Item>
      <Form.Item name={["order_id"]} label={(<>Order ID</>)}>
        <Input allowClear style={{ maxWidth: 100,}}/>
      </Form.Item>
      <Form.Item name={["rider_id"]} label={(<>Rider ID</>)}>
        <Input allowClear style={{ maxWidth: 100,}}/>
      </Form.Item>
      <Form.Item name={["issue_id"]} label={(<>Issue ID</>)} >
        <Input allowClear style={{ maxWidth: 100,}}/>
      </Form.Item>
      <Form.Item name={["agent_name"]} label={(<>Agent Name</>)} >
        <Input allowClear style={{ maxWidth: 100 }}/>
      </Form.Item>
      <Form.Item
       name={["picked"]}
       label={(<>Issues Picked</>)}
      >
        <Select
          showSearch
          allowClear
          options={issuePicked}
          style={{ minWidth: 100,}}
        />
      </Form.Item>
      <Form.Item name={["date"]} label={"Date"}>
        <RangePicker
          allowClear
          format="YYYY-MM-DD"
        />
      </Form.Item>
      <Button htmlType="submit" loading={loading || props?.pageLoader}>Search <SearchOutlined /></Button>
      <Button loading={loading || props?.pageLoader} onClick={()=>filterreset()}>Reset</Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    pageLoader: state.IssuesReducer.initialLoading,
    pageFilter: state.IssuesReducer.initialFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    issuesActions: bindActionCreators(issuesActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(IssueFilters);

